import type { BlogPost } from '../data/blogPosts';

// Stable "newest first" ordering for blog posts. Used by the homepage
// highlights and the prev/next links so they depend on post metadata rather
// than a post's raw position in the POSTS array — the daily generator inserts
// new post files, which would otherwise shuffle anything keyed off array index.
//
// Sort by date desc, then numeric id desc as a tiebreaker (many posts share a
// date once the generator runs multiple per day), then slug as a final stable
// key so the order is fully deterministic.
export function compareNewestFirst(a: BlogPost, b: BlogPost): number {
  if (a.date !== b.date) return a.date < b.date ? 1 : -1;
  const ai = Number(a.id);
  const bi = Number(b.id);
  if (Number.isFinite(ai) && Number.isFinite(bi) && ai !== bi) return bi - ai;
  if (a.slug !== b.slug) return a.slug < b.slug ? 1 : -1;
  return 0;
}

export function postsNewestFirst(posts: BlogPost[]): BlogPost[] {
  return [...posts].sort(compareNewestFirst);
}
